import { unique } from '../../utils/collections';

const LOCATION_EQUIPMENT_NAME_REGEX = `[^a-zA-Z0-9.\\\\+#: _,()&"'-]`;

export function locationEquipmentNameInvalidChars(name) {
  if (!name) return false;
  return unique(name.match(new RegExp(LOCATION_EQUIPMENT_NAME_REGEX, 'g')));
}

const DEPLOYMENT_NAME_REGEX = /^[a-zA-Z0-9_/ -]+$/;

export function deploymentNameValid(name) {
  if (!name) return false;
  return DEPLOYMENT_NAME_REGEX.test(name);
}
